
import * as t from "io-ts";
import fetchApi from "ui-io/fetch-api";
import { TransformedCompanyT } from "ui-admin/src/utils/constants";



const updateConfigCodec = t.type({
  insertedCount: t.number,
  matchedCount: t.number,
  modifiedCount: t.number,
  deletedCount: t.number,
  upsertedCount: t.number,
  upsertedIds: t.UnknownRecord,
  insertedIds: t.UnknownRecord
});


export const addBulkCompany = (data:TransformedCompanyT[]) => {

	return fetchApi({
		service: "admin-service",
		method: "POST",
		headers: { "Content-Type": "application/json" },
		pathname: `/add-bulk-company`,
		codec: updateConfigCodec ,
		body: data,
	});
};